import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { DesktopNavigation } from './DesktopNavigation';
import { MobileNavigation } from './MobileNavigation';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { NavigationState, NavigationType } from '../../states/NavigationState';
import { SimpleDesktopNavigation } from './application/SimpleDesktopNavigation';
import { SimpleMobileNavigation } from './application/SimpleMobileNavigation';
import { ComponentType } from 'react';

type Props = {
    navigationState: NavigationState;
};

@inject('navigationState')
@observer
class _Navigation extends React.Component<Props> {
    render() {
        const {
            navigationState: { currentSpec },
        } = this.props;
        switch (currentSpec.type) {
            case NavigationType.HOME:
                return GlobalStatesV3.viewport.isDesktop ? (
                    <DesktopNavigation background={currentSpec.background} />
                ) : (
                    <MobileNavigation background={currentSpec.background} showMainMenu={currentSpec.showMainMenu} />
                );
            case NavigationType.APPLICATION:
                return GlobalStatesV3.viewport.isDesktop ? <SimpleDesktopNavigation /> : null;
            case NavigationType.STANDARD:
                return GlobalStatesV3.viewport.isDesktop ? <SimpleDesktopNavigation /> : <SimpleMobileNavigation />;
            case NavigationType.NONE:
                return null;
        }
    }
}

export const Navigation = _Navigation as ComponentType<{}>;
